import {Component, Input} from '@angular/core';
import {
  Asset,
  ASSET_STATUS_CONTRACT_READY,
  ASSET_STATUS_CONTRACTED,
  ASSET_STATUS_INFO_COMPLETE,
  ASSET_STATUS_MISSING_INFO, EQUIP_TITLE_STATUS_NOT_REVIEWED, TitleStatusNameType, AssetSaleInfo
} from '../../shared/domain/item';
import {AssetPackageDto} from '../../shared/domain/asset-package';
import {MoveIndicatorControlService} from "../../shared/reload-indicator/move-indicator-control.service";
import {EQUIP_TITLE_STATUS_NOT_REVIEWED_DESC, EQUIP_TITLE_STATUS_REVIEWED_DESC,EQUIP_TITLE_STATUS_PROCESSING_DESC,EQUIP_TITLE_STATUS_NOT_READY_FOR_SALE_DESC,
  EQUIP_TITLE_STATUS_READY_FOR_SALE_DESC, EQUIP_TITLE_STATUS_IN_TRANSIT_DESC, EQUIP_TITLE_STATUS_NOT_TRANSFERABLE_DESC, EQUIP_TITLE_STATUS_TRANSFERABLE_DESC,
  EQUIP_TITLE_STATUS_TRANSFERRED_DESC, titleStatusType} from "../../shared/domain/item/title-status-type";
import { SALESHUB_CONTRACT_TYPE } from '../../shared/domain';
import {DialogService} from '@rbaip/ui-component';
import {appMessage} from '../../shared/app.message';

@Component({
  selector: 'lib-item-summary-item-badges',
  templateUrl: './item-badges.component.html',
  styleUrls: ['./item-badges.component.scss']
})
export class ItemBadgesComponent{
  @Input() asset: Asset;
  @Input() assetControlGroup: AssetPackageDto;
  @Input() assetSaleInfo: AssetSaleInfo;

  public assetMissingInfo = ASSET_STATUS_MISSING_INFO;
  public assetInfoComplete = ASSET_STATUS_INFO_COMPLETE;
  public assetContractReady = ASSET_STATUS_CONTRACT_READY;
  public assetContractedStatus = ASSET_STATUS_CONTRACTED;
  public SALESHUB_CONTRACT_TYPE = SALESHUB_CONTRACT_TYPE;

  public titleStatusName = TitleStatusNameType;
  public EQUIP_TITLE_STATUS_NOT_REVIEWED_DESC = EQUIP_TITLE_STATUS_NOT_REVIEWED_DESC;
  public EQUIP_TITLE_STATUS_REVIEWED_DESC = EQUIP_TITLE_STATUS_REVIEWED_DESC;
  public EQUIP_TITLE_STATUS_PROCESSING_DESC = EQUIP_TITLE_STATUS_PROCESSING_DESC;
  public EQUIP_TITLE_STATUS_NOT_READY_FOR_SALE_DESC = EQUIP_TITLE_STATUS_NOT_READY_FOR_SALE_DESC;
  public EQUIP_TITLE_STATUS_READY_FOR_SALE_DESC = EQUIP_TITLE_STATUS_READY_FOR_SALE_DESC;
  public EQUIP_TITLE_STATUS_IN_TRANSIT_DESC = EQUIP_TITLE_STATUS_IN_TRANSIT_DESC;
  public EQUIP_TITLE_STATUS_NOT_TRANSFERABLE_DESC = EQUIP_TITLE_STATUS_NOT_TRANSFERABLE_DESC;
  public EQUIP_TITLE_STATUS_TRANSFERABLE_DESC = EQUIP_TITLE_STATUS_TRANSFERABLE_DESC;
  public EQUIP_TITLE_STATUS_TRANSFERRED_DESC = EQUIP_TITLE_STATUS_TRANSFERRED_DESC;

  constructor(private moveIndicatorControlService: MoveIndicatorControlService,
              private dialogService: DialogService){}

  public showMe(elementName : string){
    this.moveIndicatorControlService.announce(elementName);
  }

  public displayDefaultVSODialogMessage(){
    this.dialogService.showMessageDialog(appMessage.enableVSODefaultMessage);
  }

  public displayTooltipForVSOPackage() {
    return appMessage.vsoTooltipMessage.message;
  }

}
